import MDBox from "components/MDBox";
import { dashboardCardSx } from "../constants";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";

function DashboardSummaryCard({ label, value }) {
  return (
    <Card sx={{ ...dashboardCardSx, height: "100%" }}>
      <MDBox p={2}>
        <MDTypography variant="button" color="white" textTransform="uppercase" fontWeight="bold">
          {label}
        </MDTypography>
        <MDTypography variant="h4" color="white" fontWeight="bold" mt={0.5}>
          {value}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default DashboardSummaryCard;